import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowsWidthRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4 9.2v13.6a1.2 1.2 0 1 1-2.4 0V9.2a1.2 1.2 0 1 1 2.4 0m26.4 0v13.6a1.2 1.2 0 1 1-2.4 0V9.2a1.2 1.2 0 1 1 2.4 0m-5.2 6q.8.8 0 1.6l-3.6 3.6q-.8.7-1.6 0c-.8-.7-.5-1.2 0-1.6l1.5-1.6h-11l1.5 1.6q.8.8 0 1.6a1 1 0 0 1-1.6 0l-3.6-3.6q-.7-.8 0-1.7l3.6-3.5q.8-.7 1.6 0a1 1 0 0 1 0 1.6l-1.5 1.6h11L20 13.2a1 1 0 0 1 0-1.6q.8-.7 1.6 0z"
	})
});
export default SvgArrowsWidthRegularIcon;
